export const oauth={OAUTH_TOKEN:'oauthToken',OAUTH_CALLBACK_TOKEN:'callbackToken'};